<template>
    <div
        v-if="loadingData"
        class="loader-block"
    >
        <pre-loader class="loader" />
    </div>
    <router-view />
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex';
import 'emoji-mart-vue-fast/css/emoji-mart.css';
import { CONVERSATION_ROLE } from '@/constants';
import PreLoader from './components/Common/PreLoader.vue';

export default {
  name: 'App',
  components: {
    PreLoader
  },
  computed: {
    ...mapGetters('context', ['isAuthenticated', 'currentUserId', 'isDeleted']),
    ...mapState('cache', ['chats', 'loadingData'])
  },
  watch: {
    $route() {
      this.handleDisconnectFromBroadcast();
    }
  },
  created() {
    this.$i18n.locale = window.localStorage.getItem('LOCALE-i18n');
    this.getDateSettings();
    this.$hub.on('message-received', this.handleNewMessage);
    this.$hub.on('chat-created', this.handleNewChat);
    this.$hub.on('get-chat-invitation', this.handleChatInvitation);
    this.$hub.on('new-conversation', this.handleNewConversation);
    this.$hub.on('update-friends', this.getFriendshipInfo);
    this.$hub.on('receive-friendship-offer', this.handleFriendshipOffer);
    this.$hub.on(
      'receive-friendship-acceptence',
      this.handleFriendshipAcceptence
    );
    this.$hub.on('connected', this.setHubConnectedState);
    this.$hub.on('receive-call', this.handleCall);
    this.$hub.on('add-to-call', this.handleNewCall);
    this.$hub.on('call-ended', this.stopCallNotification);
    this.$hub.on('update-notifications', this.handleNewNotification);
  },
  unmounted() {
    this.$hub.off('message-received', this.handleNewMessage);
    this.$hub.off('chat-created', this.handleNewChat);
    this.$hub.off('get-chat-invitation', this.handleChatInvitation);
    this.$hub.off('new-conversation', this.handleNewConversation);
    this.$hub.off('update-friends', this.getFriendshipInfo);
    this.$hub.off('receive-friendship-offer', this.handleFriendshipOffer);
    this.$hub.off(
      'receive-friendship-acceptence',
      this.handleFriendshipAcceptence
    );
    this.$hub.off('connected', this.setHubConnectedState);
    this.$hub.off('receive-call', this.handleCall);
    this.$hub.off('add-to-call', this.handleNewCall);
    this.$hub.off('call-ended', this.stopCallNotification);
    this.$hub.off('update-notifications', this.handleNewNotification);
  },
  mounted() {
    this.handleDisconnectFromBroadcast();
  },
  methods: {
    ...mapActions('cache', [
      'getCache',
      'getDateSettings',
      'getFriendshipInfo',
      'getNotificationsAmount',
      'setLoading'
    ]),
    ...mapMutations('cache', ['setChats']),
    ...mapMutations('context', ['setHubState']),
    async handleDisconnectFromBroadcast() {
      const id = sessionStorage.getItem('disconnectedBroadcast');
      if (id) {
        this.$hub.removeViewer(id);
        sessionStorage.removeItem('disconnectedBroadcast');
      }
    },
    handleNewMessage(message) {
      console.log(message);
      console.log(message.senderId !== this.currentUserId);
      if (message.senderId !== this.currentUserId) {
        this.notifyNewMessage(message);
      }

      const ringMessage = document.getElementById('message-ring');

      ringMessage.currentTime = 0;
      ringMessage.play();
    },
    handleNewNotification() {
      this.getNotificationsAmount();
    },
    handleNewChat(chat) {
      if (!this.chats.some(x => x.chatId === chat.chatId)) {
        const currentChats = [...this.chats];
        currentChats.unshift(chat);
        this.setChats(currentChats);
        if (chat.creatorId !== this.currentUserId) {
          this.notifyChatInvitation(chat);
        }
      }
    },
    handleChatInvitation(chat) {
      if (!this.chats.some(x => x.chatId === chat.chatId)) {
        const currentChats = [...this.chats];
        currentChats.push(chat);
        this.setChats(currentChats);
        this.notifyChatInvitation(chat);
      }
    },
    handleNewConversation(conversation) {
      if (!this.chats.some(x => x.id === conversation.id)) {
        const currentChats = [...this.chats];
        currentChats.push(conversation);
        this.setChats(currentChats);
      }
      const [message] = conversation.messages;
      conversation.lastMessage = message;
      const isSender = message.sender.id === this.currentUserId;

      if (!isSender) {
        this.notifyNewMessage(message);
        conversation.anyUnreadMessage = true;
      }
    },
    handleFriendshipOffer(user) {
      this.notifyFriendshipOffer(user);
      this.getFriendshipInfo();
    },
    handleFriendshipAcceptence(user) {
      this.notifyFriendshipAcceptence(user);
      this.getFriendshipInfo();
    },
    handleCall(chatId, withoutCall) {
      const chat = this.chats.find(x => x.chatId === chatId);

      const domain = `${window.location.protocol}//${window.location.host}`;

      if (chat.type === CONVERSATION_ROLE.Dialog) {
        this.notifyCall(
          chatId,
          () => {
            window.location.replace(`${domain}/chats/Conversation?userId=${chat.userId}&openCall=true`);
          },
          null
        );
      } else {
        this.notifyCall(
          chatId,
          async () => {
            window.location.replace(`${domain}/chats/Conversation?chatId=${chat.chatId}&openCall=true`);
          },
          withoutCall
        );
      }
    },
    handleNewCall(chat) {
      if (!this.chats.some(x => x.chatId === chat.chatId)) {
        const currentChats = [...this.chats];
        currentChats.push(chat);
        this.setChats(currentChats);
      }
      this.handleCall(chat.chatId, null);
    },
    setHubConnectedState() {
      this.setHubState(true);
    }
  }
};
</script>
<style scoped lang="scss">
.loader-block {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 102;
  background-color: #adadad42;
}
.loader{
  position: fixed;
  top:40%;
  left: 50%;
}
</style>
